module.exports = __webpack_public_path__ + "static/media/link.25b8f1d2.svg";